import { bridge, BRIDGE_METHODS } from '@h5-journey/bridge'
import { isInApp, isInWeChat } from './env'

interface NavigatorWithMsSaveOrOpenBlob extends Navigator {
  msSaveOrOpenBlob?: (blob: Blob, defaultName?: string) => boolean
}

/**
 * 触发浏览器下载指定 URL 文件
 * @param url 文件地址
 * @param filename 下载后的文件名
 */
export async function downloadFile(url: string, filename?: string): Promise<void> {
  if (!url) {
    console.error('downloadFile: url is empty')
    return
  }

  // 微信内置浏览器：blob URL 跨页失效，跳转外部浏览器后无法访问，直接打开原链接
  if (isInWeChat()) {
    window.open(url, '_blank')
    return
  }

  // APP（Flutter WebView）：不支持 blob/跨域文件下载，launchUrl 调系统浏览器打开（可预览可下载）
  if (isInApp()) {
    try {
      await bridge.invoke(BRIDGE_METHODS.LAUNCHURL, { url, mode: 'externalApplication' })
    } catch (error) {
      console.error('downloadFile: launchUrl failed', error)
    }
    return
  }

  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`下载失败: ${response.status}`)
    }

    const blob = await response.blob()

    // IE10/11 fallback
    const navigatorWithMsSave = window.navigator as NavigatorWithMsSaveOrOpenBlob
    if (navigatorWithMsSave.msSaveOrOpenBlob) {
      navigatorWithMsSave.msSaveOrOpenBlob(blob, filename || 'download')
      return
    }

    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = filename || ''
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('downloadFile failed', error)
    throw error
  }
}
